// removed by extract-text-webpack-plugin
module.exports = {"companies-methodology-link":"companies-methodology-link___3hds7"};